import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type SelectedService from '../services/kolay/selected.ts';
import type { ComponentLike } from '@glint/template';
export class Page extends Component<{
    Blocks: {
        /**
     * If there was a compilation error, the `<:error>` block
     * will be active and pass the caller the error text from the compiler.
     *
     * Example:
     *
     * ```gjs
     * import { Page } from 'kolay/components';
     *
     * <template>
     *   <Page>
     *     <:error as |errorText|>
     *
     *       {{errorText}}
     *
     *     </:error>
     *     <:success></:success>
     *   </Page>
     * </template>
     * ```
     */ error: [error: string];
        /**
     * If compilation of the active page was successful, the `<:success>` black
     * will be active, and will pass the component reference to the caller.
     *
     * Example:
     * ```gjs
     * import { Page } from 'kolay/components';
     *
     * <template>
     *   <Page>
     *     <:error></:error>
     *     <:success as |prose|>
     *
     *       <prose />
     *
     *     </:success>
     *   </Page>
     * </template>
     * ```
     */ success: [prose: ComponentLike<{
            }>];
    };
}> {
    static{
        template(`
    {{#if this.selected.hasError}}
      {{yield this.selected.error to='error'}}
    {{/if}}

    {{#if this.selected.prose}}
      {{yield this.selected.prose to='success'}}
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @service('kolay/selected')
    selected: SelectedService;
}
export default Page;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvdWkvc3JjL2NvbXBvbmVudHMvcGFnZS5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuaW1wb3J0IHsgc2VydmljZSB9IGZyb20gJ0BlbWJlci9zZXJ2aWNlJztcblxuaW1wb3J0IHR5cGUgU2VsZWN0ZWRTZXJ2aWNlIGZyb20gJy4uL3NlcnZpY2VzL2tvbGF5L3NlbGVjdGVkLnRzJztcbmltcG9ydCB0eXBlIHsgQ29tcG9uZW50TGlrZSB9IGZyb20gJ0BnbGludC90ZW1wbGF0ZSc7XG5cbmV4cG9ydCBjbGFzcyBQYWdlIGV4dGVuZHMgQ29tcG9uZW50PHtcbiAgQmxvY2tzOiB7XG4gICAgLyoqXG4gICAgICogSWYgdGhlcmUgd2FzIGEgY29tcGlsYXRpb24gZXJyb3IsIHRoZSBgPDplcnJvcj5gIGJsb2NrXG4gICAgICogd2lsbCBiZSBhY3RpdmUgYW5kIHBhc3MgdGhlIGNhbGxlciB0aGUgZXJyb3IgdGV4dCBmcm9tIHRoZSBjb21waWxlci5cbiAgICAgKlxuICAgICAqIEV4YW1wbGU6XG4gICAgICpcbiAgICAgKiBgYGBnanNcbiAgICAgKiBpbXBvcnQgeyBQYWdlIH0gZnJvbSAna29sYXkvY29tcG9uZW50cyc7XG4gICAgICpcbiAgICAgKiA8dGVtcGxhdGU-XG4gICAgICogICA8UGFnZT5cbiAgICAgKiAgICAgPDplcnJvciBhcyB8ZXJyb3JUZXh0fD5cbiAgICAgKlxuICAgICAqICAgICAgIHt7ZXJyb3JUZXh0fX1cbiAgICAgKlxuICAgICAqICAgICA8LzplcnJvcj5cbiAgICAgKiAgICAgPDpzdWNjZXNzPjwvOnN1Y2Nlc3M-XG4gICAgICogICA8L1BhZ2U-XG4gICAgICogPC90ZW1wbGF0ZT5cbiAgICAgKiBgYGBcbiAgICAgKi9cbiAgICBlcnJvcjogW2Vycm9yOiBzdHJpbmddO1xuICAgIC8qKlxuICAgICAqIElmIGNvbXBpbGF0aW9uIG9mIHRoZSBhY3RpdmUgcGFnZSB3YXMgc3VjY2Vzc2Z1bCwgdGhlIGA8OnN1Y2Nlc3M-YCBibGFja1xuICAgICAqIHdpbGwgYmUgYWN0aXZlLCBhbmQgd2lsbCBwYXNzIHRoZSBjb21wb25lbnQgcmVmZXJlbmNlIHRvIHRoZSBjYWxsZXIuXG4gICAgICpcbiAgICAgKiBFeGFtcGxlOlxuICAgICAqIGBgYGdqc1xuICAgICAqIGltcG9ydCB7IFBhZ2UgfSBmcm9tICdrb2xheS9jb21wb25lbnRzJztcbiAgICAgKlxuICAgICAqIDx0ZW1wbGF0ZT5cbiAgICAgKiAgIDxQYWdlPlxuICAgICAqICAgICA8OmVycm9yPjwvOmVycm9yPlxuICAgICAqICAgICA8OnN1Y2Nlc3MgYXMgfHByb3NlfD5cbiAgICAgKlxuICAgICAqICAgICAgIDxwcm9zZSAvPlxuICAgICAqXG4gICAgICogICAgIDwvOnN1Y2Nlc3M-XG4gICAgICogICA8L1BhZ2U-XG4gICAgICogPC90ZW1wbGF0ZT5cbiAgICAgKiBgYGBcbiAgICAgKi9cbiAgICBzdWNjZXNzOiBbcHJvc2U6IENvbXBvbmVudExpa2U8e30-XTtcbiAgfTtcbn0-IHtcbiAgPHRlbXBsYXRlPlxuICAgIHt7I2lmIHRoaXMuc2VsZWN0ZWQuaGFzRXJyb3J9fVxuICAgICAge3t5aWVsZCB0aGlzLnNlbGVjdGVkLmVycm9yIHRvPSdlcnJvcid9fVxuICAgIHt7L2lmfX1cblxuICAgIHt7I2lmIHRoaXMuc2VsZWN0ZWQucHJvc2V9fVxuICAgICAge3t5aWVsZCB0aGlzLnNlbGVjdGVkLnByb3NlIHRvPSdzdWNjZXNzJ319XG4gICAge3svaWZ9fVxuICA8L3RlbXBsYXRlPlxuXG4gIEBzZXJ2aWNlKCdrb2xheS9zZWxlY3RlZCcpIGRlY2xhcmUgc2VsZWN0ZWQ6IFNlbGVjdGVkU2VydmljZTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgUGFnZTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxlQUFlLHFCQUFxQjtBQUMzQyxTQUFTLE9BQU8sUUFBUSxpQkFBaUI7QUFFekMsWUFBWSxxQkFBcUIsZ0NBQWdDO0FBQ2pFLGNBQWMsYUFBYSxRQUFRLGtCQUFrQjtBQUVyRCxPQUFPLE1BQU0sYUFBYTtJQUN4QjtRQUNFOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztLQW9CQyxHQUNELFFBQVEsT0FBTyxNQUFNO1FBQ3JCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0tBbUJDLEdBQ0QsVUFBVSxPQUFPOzs7O0lBR25CLE1BQUE7UUFBQSxTQUFVLENBQUE7Ozs7Ozs7O0VBUVYsQ0FBQSxFQUFBO1lBQUEsV0FBQSxJQUFXO1lBQVg7Z0JBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO1lBQUQ7UUFBQTtJQUFBLENBUkE7SUFVVixDQUFDLFFBQVE7SUFBMEIsVUFBVSxnQkFBZ0I7QUFDL0Q7QUFFQSxlQUFlLEtBQUsifQ